import { Outlet } from 'react-router-dom';
import LoginPage from '../../../container/LoginPage';
import { useAuth } from '../../../context/Auth';

const ProtectedRoute = () => {
    const auth = useAuth();

    if (!auth.user) {
        return <LoginPage />;
    }
    return <Outlet />;
};

export default ProtectedRoute;
